var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"send-voice-tip"},[_vm._v("开启后，客户可在移动端网页咨询窗口发送"+_vm._s(_vm.type === 'file' ? '文件' : '图片'))])}
var staticRenderFns = []

export { render, staticRenderFns }